import apiWrapper from "@apiWrapper";

export const exportDocumentFromHtml = async (
  html: string,
  format: "pdf" | "docx"
) => {
  const response = await apiWrapper("/documents/tmp", "POST", {
    html,
    type: format,
  });

  return response.data;
};
